import { render, staticRenderFns } from "./fileEdit.vue?vue&type=template&id=276dfd5b&scoped=true"
import script from "./fileEdit.vue?vue&type=script&lang=js"
export * from "./fileEdit.vue?vue&type=script&lang=js"
import style0 from "./fileEdit.vue?vue&type=style&index=0&id=276dfd5b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276dfd5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/c-webhlzfq_workbench-web_en_test/orca-ac-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276dfd5b')) {
      api.createRecord('276dfd5b', component.options)
    } else {
      api.reload('276dfd5b', component.options)
    }
    module.hot.accept("./fileEdit.vue?vue&type=template&id=276dfd5b&scoped=true", function () {
      api.rerender('276dfd5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cloudSpace/components/fileEdit.vue"
export default component.exports